// 全局主题色规范 — 遇到标题/副标题/强调色/页面背景语义时直接引用这些常量
export const COLOR_ORANGE = '#FF7136' // 按钮、链接、强调标识、激活态
export const COLOR_ORANGE_LIGHT = '#FFBCA1' // 按钮边框、描述文本
export const COLOR_PEACH_LIGHT = '#FFEDEA' // 卡片背景、辅助元素
export const COLOR_TITLE = '#2A384B' // 页面标题、卡片标题、主要文本
export const COLOR_SUBTITLE = '#94A7BF' // 描述文字、次要说明、辅助信息
export const COLOR_PAGE_BG = '#F5F5F5' // 屏幕根容器背景
